export const formatDate = (date: string | Date, locale = 'fr-FR') => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

export const formatCurrency = (
  amount: number,
  currency = 'EUR',
  locale = 'fr-FR'
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);
};

export const formatDateTime = (date: string | Date, locale = 'fr-FR') => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

export const formatTimeAgo = (date: string | Date, locale = 'fr-FR') => {
  const now = new Date();
  const targetDate = new Date(date);
  const diffInMs = now.getTime() - targetDate.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInMinutes < 1) {
    return locale === 'fr-FR' ? "À l'instant" : 'Just now';
  } else if (diffInMinutes < 60) {
    return locale === 'fr-FR'
      ? `Il y a ${diffInMinutes} min`
      : `${diffInMinutes}m ago`;
  } else if (diffInHours < 24) {
    return locale === 'fr-FR'
      ? `Il y a ${diffInHours}h`
      : `${diffInHours}h ago`;
  } else if (diffInDays < 7) {
    return locale === 'fr-FR' ? `Il y a ${diffInDays}j` : `${diffInDays}d ago`;
  } else {
    return formatDate(date, locale);
  }
};

// Export object for easier imports
export const format = {
  date: formatDate,
  dateTime: formatDateTime,
  timeAgo: formatTimeAgo,
  currency: formatCurrency,
};
